import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel, FormControl, Checkbox} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import Validator from "../../../../../utilities/Validator";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import NumberUtilities from "../../../../../utilities/NumberUilities";
import LogowanieService from "../../../../logowanie/LogowanieService";

export default class PrzystankiForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nazwa: '',
            wybranaMiejscowosc: null,
            szerokosc_geo: '',
            dlugosc_geo: '',
            czyBylPrzycisk: false,
            validatorMessages: [],
            domyslny:0,
        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onChangeMiejscowosc = this.onChangeMiejscowosc.bind(this)
        this.onChangeNazwa = this.onChangeNazwa.bind(this)
        this.onChangeSzerokosc = this.onChangeSzerokosc.bind(this)
        this.onChangeDlugosc = this.onChangeDlugosc.bind(this)
        this.onClickDomyslny = this.onClickDomyslny.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.przystanek)) {
            this.setState(
                {
                    nazwa: this.props.przystanek.nazPr,
                    wybranaMiejscowosc: this.props.miejscowosci.find(m => m.idMi === this.props.przystanek.idMi),
                    szerokosc_geo: this.props.przystanek.szGps,
                    dlugosc_geo: this.props.przystanek.dlGps,
                    domyslny: (this.props.przystanek.domyslny===1)? 1:0
                }
            )
        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.przystanek) {
            this.setState(
                {
                    nazwa: nextprops.przystanek.nazPr,
                    wybranaMiejscowosc: this.props.miejscowosci.find(m => m.idMi === nextprops.przystanek.idMi),
                    szerokosc_geo: nextprops.przystanek.szGps,
                    dlugosc_geo: nextprops.przystanek.dlGps,
                    domyslny: (nextprops.przystanek.domyslny===1)? 1:0
                }
            )
            document.getElementById('InputNazwaPrzystanku').value = nextprops.przystanek.nazMi;
            document.getElementById('InputSzerokosc').value = nextprops.przystanek.szGps;
            document.getElementById('InputDlugosc').value = nextprops.przystanek.dlGps;
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {

        this.setState({czyBylPrzycisk: true, validatorMessages: []})

        let poprawne = true; this.state.validatorMessages = [];

        if (!Boolean(this.state.wybranaMiejscowosc)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Miejscowość nie jest wybrana')
        }
        if (this.state.nazwa.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Przystanek nie jest uzupełniony')

        }
        if (Boolean(this.state.szerokosc_geo)){
            if (!Validator.validateIntOrDouble(this.state.szerokosc_geo) || !Validator.validateSzerokoscDlugoscWysokoscGeo(this.state.szerokosc_geo, 'sz')) {

                poprawne = false;
                this.dodajDoValidatorMessages('Szerokość geograficzna jest niepoprawna')
            }
        }

        if (Boolean(this.state.dlugosc_geo)){
            if ((!Validator.validateIntOrDouble(this.state.dlugosc_geo) || !Validator.validateSzerokoscDlugoscWysokoscGeo(this.state.dlugosc_geo, 'dl'))) {
                poprawne = false;
                this.dodajDoValidatorMessages('Długość geograficzna jest niepoprawna')
            }
        }

        if (poprawne) {
            this.state.validatorMessages = [];
            this.setState({czyBylPrzycisk: false, validatorMessages: []})

            let data = {
                "idMi": this.state.wybranaMiejscowosc.idMi,
                "nazMi": this.state.wybranaMiejscowosc.nazMi,
                "nazPr": this.state.nazwa,
                "szGps": Boolean(this.state.szerokosc_geo)?NumberUtilities.parseStringToNumber(this.state.szerokosc_geo):null,
                "dlGps":  Boolean(this.state.dlugosc_geo)?NumberUtilities.parseStringToNumber(this.state.dlugosc_geo):null,
                "gpsDataAktualizacji":  new Date().toISOString(),
                "gpsWpisal": Boolean(this.props.przystanek)? this.props.przystanek.gpsWpisal : LogowanieService.pobierzLoginZalogowanego(),
                "domyslny": this.state.domyslny
            };

            if (Boolean(this.props.przystanek)) {
                // edycja
                this.props.handleClickZapisz(data, true)
            }
            else {
                // dodawanie
                this.props.handleClickZapisz(data, false)
            }
        }
    }

    onChangeMiejscowosc(e) {
        this.setState({wybranaMiejscowosc: e})
    }

    onChangeNazwa(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 60, 'InputNazwaPrzystanku', this.state.nazwa)) {
            this.setState({nazwa: e.target.value})
        }
    }

    onChangeSzerokosc(e) {
        this.setState({szerokosc_geo: e.target.value})
    }

    onChangeDlugosc(e) {
        this.setState({dlugosc_geo: e.target.value})
    }


    onClickDomyslny(){
        if(this.state.domyslny===1){
            this.setState({domyslny:0})
        }
        else this.setState({domyslny:1})
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.przystanek) ? 'Edycja przystanku' : 'Nowy przystanek'}</div>
                <Form horizontal={true}>
                    <FormGroup>
                        <Col xs={12} sm={6} md={4} lg={2}>
                            <ControlLabel>
                                Miejscowość <span className={'req'}>*</span>
                            </ControlLabel>
                            <TopSelect onChange={this.onChangeMiejscowosc} value={this.state.wybranaMiejscowosc} options={this.props.miejscowosci}
                                       valueKey={'idMi'} labelKey={'nazMi'}/>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3}>
                            <ControlLabel>
                                Nazwa przystanku <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nazwa.length}/60 znaków</span>
                            </ControlLabel>
                            <FormControl onChange={this.onChangeNazwa}
                                         defaultValue={Boolean(this.props.przystanek) ? this.props.przystanek.nazPr : ''}
                                         id={'InputNazwaPrzystanku'}/>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={2}>
                            <div className={'add-label-margin'}></div>
                            <Checkbox onClick={this.onClickDomyslny} checked={Boolean(this.state.domyslny===1)}><span style={{fontWeight:'bold'}}>Czy domyślny?</span></Checkbox>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col xs={12} sm={6} md={4} lg={2}>
                            <ControlLabel>
                                Szerokość geo.
                            </ControlLabel>
                            <FormControl onChange={this.onChangeSzerokosc}
                                         defaultValue={Boolean(this.props.przystanek) ? this.props.przystanek.szGps : ''} id={'InputSzerokosc'}/>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={2}>
                            <ControlLabel>
                                Długość geo.
                            </ControlLabel>
                            <FormControl onChange={this.onChangeDlugosc}
                                         defaultValue={Boolean(this.props.przystanek) ? this.props.przystanek.dlGps : ''} id={'InputDlugosc'}/>
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={3}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonCancel onClick={() => {
                                this.props.handleClickAnuluj()
                            }} text={'Anuluj'}/>
                            <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <ValidatorMessages messages={this.state.validatorMessages}/>
                    </FormGroup>
                </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/przystanki/components/PrzystankiForm.js